import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/close.svg
var t = (t) => /* @__PURE__ */ e("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...t,
	children: /* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M9.533 8.12a.167.167 0 0 1 0-.237l6.174-6.174A1 1 0 0 0 14.291.295L8.117 6.467a.167.167 0 0 1-.236 0L1.707.295A1 1 0 0 0 .293 1.71l6.173 6.174a.167.167 0 0 1 0 .236L.293 14.294a1 1 0 1 0 1.414 1.414l6.174-6.175a.167.167 0 0 1 .236 0l6.174 6.175a1 1 0 1 0 1.415-1.414z"
	})
});
//#endregion
export { t as default };
